import { gql } from "@apollo/client";

export const ADD_CATEGORY=gql`
mutation addSubjectCategory($category: String!,$sjId:String!) {
  addSubjectCategory(category: $category, sjId: $sjId)
}
`;

export const GET_CATEGORY=gql`
query getSubjectCategories($sjId: UUID!) {
  allSubjectCategories(
    filter: {deletedAt: {isNull: true}, sjId: {equalTo: $sjId}}
    orderBy: SC_NAME_CAPITALIZED_ASC
  ) {
    nodes {
      scNameCapitalized
      scId
    }
  }
}
`;

export const INSERT_SYNDICATED_VIDEOS=gql`
mutation insertSyndicatedVideos($cId: UUID!, $ctId: UUID!, $coverImagePath: String = null, $filename: String!, $filepath: String!, $filesize: BigInt!, $isClassRoom: Boolean!, $lId: UUID!, $sjId: UUID!) {
  uploadMylibrarySyndicatedVideos(
    input: {pCategoryId: $ctId, pClassroomId: $cId, pCoverImagePath: $coverImagePath, pFilename: $filename, pFilepath: $filepath, pFilesize: $filesize, pIsClassroom: $isClassRoom, pLId: $lId, pSubjectId: $sjId}
  ) {
    clientMutationId
  }
}
`;

export const GET_ALL_SYNDICATED_VIDEOS=gql`
query getSyndicatedVideos($input: getSyndicatedVideosInput!) {
  getSyndicatedVideos(input: $input) {
    categoryName
    categoryOriginalName
    categoryId
    datas {
      categoryId
      categoryName
      coverImagePath
      fileId
      filename
      filepath
      filesize
      isClassroom
      playbackTime
      feedId
    }
    totalCount
  }
}
`;


export const UPDATE_PLAY_BACK_TIME_FOR_SYNDICATED_VIDEO = gql`
mutation upsertVideosPlaybacktime($input: UpsertVideosPlaybacktimeInput!) {
  upsertVideosPlaybacktime(input: $input) {
    clientMutationId
  }
}
`